import type { TickSystem } from '@app-games/core';
import type { GameState } from '../state.js';
import type { GameAction } from '../actions.js';
import { MAX_ENERGY } from '../state.js';

let lastTickTime = 0;
const TICK_INTERVAL = 5; // 5초마다 체크

export const energySystem: TickSystem<GameState, GameAction> = {
  name: 'energy',

  update(state, deltaTime, dispatch) {
    if (state.energy >= MAX_ENERGY) return state;

    lastTickTime += deltaTime;
    if (lastTickTime < TICK_INTERVAL) return state;
    lastTickTime = 0;

    dispatch({ type: 'TICK_ENERGY', payload: { now: Date.now() } });
    return state;
  }
};
